import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';

import { RiskAreaFilters } from '../../../commons/models/risk-area.model';

@Component({
  selector: 'app-risk-area-filters',
  templateUrl: './risk-area-filters.component.html',
  styleUrls: ['./risk-area-filters.component.scss']
})
export class RiskAreaFiltersComponent {


  @Output()
  onFilter: EventEmitter<RiskAreaFilters> = new EventEmitter();

  private _defaultFilters: RiskAreaFilters;
  filtersForm: FormGroup;

  constructor(private fb: FormBuilder) {
    this._createForm();
  }

  private _createForm() {
    let group = {
      search: "",
    }

    this.filtersForm = this.fb.group(group);
  }

  applyFilters() {
    this.onFilter.emit(this._getRiskAreaFilters());
  }

  private _getRiskAreaFilters(): RiskAreaFilters {
    let filters: RiskAreaFilters = {}
    if (this.filtersForm) {
      const values = this.filtersForm.value;
      filters.search = values.search;
    }
    return filters;
  }

  resetFilters() {
    this.filtersForm.reset();
    this.filtersForm.patchValue({
      search: "",
    });
    this._setDefaultValues();
    this.applyFilters();
  }

  get defaultFilters(): RiskAreaFilters {
    return this._defaultFilters;
  }

  @Input()
  set defaultFilters(defaultFilters: RiskAreaFilters) {
    this._defaultFilters = defaultFilters;
    this._setDefaultValues();
  }

  private _setDefaultValues() {
    if (this.defaultFilters) {
      if (this.filtersForm) {
        this.filtersForm.patchValue({
          search: this.defaultFilters.search,
        })
      }
    }
  }
}
